import * as React from 'react';

import '../css/style-fed-cbhb.css'
import '../css/custom-fed-cbhb.css'

const ThemeFED = () => <></>;

export default ThemeFED;
